import { cn } from '../lib/utils';
import styles from './index.module.scss';

export default function Button({
    children,
    className,
    variant = 'secondary', //primary, secondary, outline , ghost
    size = 'lg', // sm, lg
    rounded = 'rounded_md', // rounded_sm, rounded_md, rounded_lg, rounded_full, rounded_none
    ...props
}) {
    return (
        <button className={cn(styles.button, styles[variant], styles[size], styles[rounded], className)} {...props}>
            {children}
        </button>
    );
}
